export default __webpack_public_path__ + "static/media/sec-1-en.f6d85a3b.png";